import jsPDF from 'jspdf';

export const generatePaystubPDF = async (
  paystub: any,
  formatAmount: (a: number) => string,
  logoDataUrl: string, // already base64 string
  companyName: string,
  salaryMemo1: string

) => {
  const doc = new jsPDF();
  const lineHeight = 10;
  let y = 20;

  // 🧠 Create <img> and wait for it to load, to get width/height
  const image = new Image();
  image.src = logoDataUrl;
  await new Promise<void>((resolve, reject) => {
    image.onload = () => resolve();
    image.onerror = reject;
  });

  const desiredWidth = 60;
  const aspectRatio = image.height / image.width;
  const scaledHeight = desiredWidth * aspectRatio;

  doc.addImage(logoDataUrl, 'PNG', 10, 10, desiredWidth, scaledHeight);
  y += scaledHeight + 10;

  doc.setFontSize(18);
  doc.text(`Paystub for ${paystub.name}`, 10, y);
  y += lineHeight + 2;

  doc.setFontSize(12);
  doc.text(`Government ID: ${paystub.governmentId || 'N/A'}`, 10, y);
  y += lineHeight;
  doc.text(`Email: ${paystub.email}`, 10, y);
  y += lineHeight;
  doc.text(`Pay Period: ${paystub.payPeriod.start} to ${paystub.payPeriod.end}`, 10, y);
  y += lineHeight;
  doc.text(`Paid On: ${paystub.payPeriod.paidOn}`, 10, y);
  y += lineHeight + 5;

  doc.setFillColor(230, 244, 234); // Net Pay box
  doc.rect(10, y, 90, 20, 'F');
  doc.setFontSize(14);
  doc.text('Net Pay', 12, y + 7);
  doc.setFontSize(16);
  doc.text(`AED ${formatAmount(paystub.netPay)}`, 12, y + 15);

  doc.setFillColor(242, 242, 242); // Gross Pay box
  doc.rect(110, y, 90, 20, 'F');
  doc.setFontSize(14);
  doc.text('Net Pay (YTD)', 112, y + 7);
  doc.setFontSize(16);
  doc.text(`AED ${formatAmount(paystub.netPayYtd)}`, 112, y + 15);

  y += 30;

  doc.setFontSize(14);
  doc.text('Earnings', 10, y);
  y += lineHeight;

  doc.setFontSize(12);
  doc.setDrawColor(200);
  doc.setFillColor(249, 249, 249);
  doc.rect(10, y - 6, 190, 8, 'F');
  doc.text('Type', 12, y);
  doc.text('Current (AED)', 120, y, { align: 'right' });
  doc.text('YTD (AED)', 200, y, { align: 'right' });
  y += lineHeight;

  /*
  paystub.earnings.forEach((e: any) => {
    doc.text(e.type, 12, y);
    doc.text(formatAmount(e.amount), 120, y, { align: 'right' });
    doc.text(formatAmount(e.amount_ytd), 200, y, { align: 'right' });
    y += lineHeight;
  });
  */

  paystub.earnings.forEach((e: any) => {
    const wrappedType = doc.splitTextToSize(e.type, 100); // wrap within 100 units
    const lineCount = wrappedType.length;
    const blockHeight = lineCount * lineHeight;
    
    doc.text(wrappedType, 12, y);
    doc.text(formatAmount(e.amount), 120, y, { align: 'right' });
    doc.text(formatAmount(e.amount_ytd), 200, y, { align: 'right' });
    
    y += blockHeight;
  });

  y += 10;

  /*
  doc.setFontSize(14);
  doc.text('Available Time Off', 10, y);
  y += lineHeight;

  doc.setFontSize(12);
  doc.setFillColor(253, 246, 236);
  doc.rect(10, y, 90, 15, 'F');
  doc.text(`Vacation: ${paystub.timeOff.vacation} hrs`, 12, y + 10);

  doc.setFillColor(253, 246, 236);
  doc.rect(110, y, 90, 15, 'F');
  doc.text(`Sick: ${paystub.timeOff.sick} hrs`, 112, y + 10);
  */

  // Salary Memo Box
  if (salaryMemo1) {
    const memoLines = doc.splitTextToSize(salaryMemo1, 95); // ~half page
    const visibleLines = memoLines.slice(0, 3); // Max 3 lines
    const boxHeight = visibleLines.length * lineHeight + 6;

    doc.setFillColor(245, 245, 245); // light grey
    doc.rect(10, y, 95, boxHeight, 'F');

    doc.setTextColor(51, 51, 51);
    doc.setFontSize(11);
    doc.text(visibleLines, 12, y + lineHeight);
    y += boxHeight + 10;
  }

  // Add footer with company name
  doc.setFontSize(10);
  doc.text(companyName, 105, 290, { align: 'center' });

  return doc;
};

export const generatePaystubWithLogo = async (
  paystub: any,
  formatAmount: (a: number) => string,
  logoUrl: string,
  companyName: string,
  salaryMemo1: string
) => {
  const image = await loadImageAsBase64(logoUrl);
  const doc = await generatePaystubPDF(paystub, formatAmount, image, companyName,salaryMemo1);
  return doc;
};

const loadImageAsBase64 = (url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Canvas context is null'));
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
};

